import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

export interface Phone { label: string; number: string; whatsapp?: string }
export interface Settings {
  business_name: string;
  tagline: string;
  email: string;
  support_email?: string;
  booking_email?: string;
  business_phone?: string;
  support_hours?: string;
  phones: Phone[];
  offices: { name: string; address: string; status: string }[];
  social: Record<string, string>;
  hero: { eyebrow: string; title: string; subtitle: string };
  home: Record<string, any>;
  service_status: Record<string, string>;
  transfers: { intro: string; airports: string[] };
  founder: { name: string; title: string; bio: string; portrait_url: string; approved: boolean };
  gant_estate: { intro: string; disclaimer: string };
  payments_enabled: boolean;
  deposit_percent: number;
  footer_text: string;
  announcement?: string;
  shipping?: { requests_open: boolean; routes: string; pricing: string; pickup_slot_capacity?: number };
  mission?: { statement: string; vision: string; vision_points: string[]; closing: string };
}

const Ctx = createContext<{ s: Settings | null; reload: () => void }>({ s: null, reload: () => {} });

export const SettingsProvider = ({ children }: { children: React.ReactNode }) => {
  const [s, setS] = useState<Settings | null>(null);
  const reload = useCallback(() => {
    api.get("/settings").then((r) => setS(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    reload();
  }, [reload]);
  return <Ctx.Provider value={{ s, reload }}>{children}</Ctx.Provider>;
};

export const useSettings = () => useContext(Ctx);
